const FINISHED_FIXTURE_STATES = new Set(["FT", "FT_PEN", "AET"]);

export function getLeagueFixtureState(fixture) {
  return String(
    fixture?.state?.state ||
    fixture?.state?.short_name ||
    fixture?.state?.developer_name ||
    ""
  ).toUpperCase();
}

export const isLeagueFixtureFinished = (fixture) =>
  FINISHED_FIXTURE_STATES.has(getLeagueFixtureState(fixture));

export function getAutomaticLeagueAnalysisPhase(fixtures) {
  const relevant = Array.isArray(fixtures) ? fixtures : [];
  return relevant.length > 0 && relevant.every(isLeagueFixtureFinished)
    ? "post"
    : "pre";
}

export function getManualLeagueAnalysisPhase(current, requested, fixtures) {
  if (requested === "pre") return "pre";
  if (requested === "post" && (fixtures || []).some(isLeagueFixtureFinished)) {
    return "post";
  }
  return current;
}
